var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.labelarr),function(itemr,index){return _c('el-tag',{key:index,staticClass:"tag_box"},[_vm._v(_vm._s(itemr.tag_name))])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }